<template>
  <div class="organization-manage">
    <!-- 当前企业信息 -->
    <div>
      <div>当前企业</div>
      <div class="search-box">
        <div>{{$store.state.user.defaultCompanyName}}
          <span class="auth-company">{{defaultCompanyStatus === '40' ? '已认证': defaultCompanyStatus === '20' ? '认证中': '未认证'}}</span>
        </div>
        <div>
          <el-button type="primary"
                     @click="createCompany()">创建新公司</el-button>
        </div>
      </div>
    </div>
    <!-- 导航 -->
    <!-- <div class="org-nav">
      <div v-for="item in navList"
           :key="item.value"
           :class="{'org-nav-item-selected':activeNav===item.value}"
           class="org-nav-item" @click="changeActiveNav(item.value)">{{item.name}}</div>
    </div> -->
    <el-tabs v-model="activeNav"
             v-if="show"
             @tab-click="handleClick">
      <el-tab-pane label="员工管理"
                   name="employee">
        <employee ref="employee"></employee>
      </el-tab-pane>
      <el-tab-pane label="岗位管理"
                   name="post">
        <post ref="post"></post>
      </el-tab-pane>
      <el-tab-pane label="离职员工"
                   name="leave-employee">
        <leave-employee ref="leave-employee"></leave-employee>
      </el-tab-pane>
      <el-tab-pane name="employee-app">

        <span slot="label">
          <el-badge :value="number"
                    :max="99"
                    :hidden="number === 0"
                    class="item">加入申请 </el-badge>
        </span>
        <employee-app ref="employee-app"></employee-app>
      </el-tab-pane>
    </el-tabs>
    <company-add ref="companyAdd"
                 v-if="companyAddVisible"></company-add>
    <el-dialog title="提示"
               :visible.sync="showMost"
               width="30%">
      <!-- :before-close="handleClose" -->
      <span>{{currentCompanyStatus === '20' ? '企业正在审核，请耐心等待' : '仅限认证企业可访问该服务，现在认证即时开通，无需等待'}}</span>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="routerjump('basicInfo')">取 消</el-button>
        <el-button type="primary"
                   @click="routerjump(currentCompanyStatus === '20' ?'basicInfo': 'enterpriseCertification')">{{currentCompanyStatus === '20' ? '确认' : '去认证'}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Employee from './employee'
import Post from './post'
import LeaveEmployee from './leave-employee'
import CompanyAdd from './company-add'
import EmployeeApp from './employee-app'
export default {
  data () {
    return {
      showMost: false,
      number: 0,
      show: false,
      activeNav: 'employee',
      // defaultCompanyStatus: '', // 默认公司认证状态
      navList: [
        {
          name: '员工管理',
          value: 'employee'
        },
        {
          name: '岗位管理',
          value: 'post'
        },
        {
          name: '离职员工',
          value: 'staffLeaving'
        }
      ],
      companyAddVisible: false
    }
  },
  components: {
    Employee,
    Post,
    LeaveEmployee,
    CompanyAdd,
    EmployeeApp
  },
  computed: {
    currentCompanyStatus () {
      let company = this.$store.state.user.companyAccountInfo.find(item => {
        return item.companyId === item.defaultCompanyId
      })
      return company ? company.authentFlag : ''
    },
    defaultCompanyStatus () {
      let company = this.$store.state.user.companyAccountInfo.find(item => {
        return item.companyId === item.defaultCompanyId
      })
      return company ? company.authentFlag : ''
    }
  },
  watch: {
    '$route.name': {
      handler (val) {
        if (val === 'postAddOrUpdate') {
          this.activeNav = 'post'
        }
      },
      immediate: true
    },
    currentCompanyStatus () {
      if (this.currentCompanyStatus !== '40') {
        this.showMost = true
      } else {
        this.showMost = false
      }
    }
  },
  created () {
    if (!this.bus._events['getUserNumber']) {
      this.bus.$on('getUserNumber', () => {
        this.getNumber()
      })
    }
  },
  mounted () {
    this.getGuanli()
  },
  methods: {
    getGuanli () {
      this.$http
        .post(`/help/user/sys/custUser/isCompanyManager`, {
          companyId: this.$store.state.user.defaultCompanyId
        }).then(({ data: res }) => {
          if (res.data === true) {
            this.show = true
            this.getNumber()
          } else {
            this.show = false
            this.$router.replace({ name: 'basicInfo' })
          }
        })
    },
    getNumber () {
      this.$http
        .get(`/front/consumer/usercenter/unhandled-apply-users-count`, {
          params: {
            companyId: this.$store.state.user.defaultCompanyId
          }
        })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.number = res.data
          } else {
            this.number = 0
          }
        })
    },
    handleClick (newTab) {
      this.activeNav = newTab.name
      this.$refs[newTab.name].getDataList(1)
    },
    // 创建新公司
    createCompany () {
      let flag1 = this.$store.state.user.companyAccountInfo.some(item => {
        return item.authentFlag !== '40'
      })
      let flag2 = this.$store.state.user.companyAccountInfo.some(item => {
        return item.authentFlag === '20'
      })
      if (flag2) {
        // this.$store.state.user.defaultCompanyAuthentFlag === '20'
        return this.$confirm('企业正在审核，请耐心等待', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        }).catch(() => { })
      } else if (flag1) {
        // this.$store.state.user.defaultCompanyAuthentFlag !== '40'
        this.$confirm('认证企业才能新建企业账号，现在认证即时开通，无需等待！', '提示', {
          confirmButtonText: '去认证',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$router.push({ name: 'enterpriseCertification' })
        }).catch(() => { })
      } else {
        this.companyAddVisible = true
        this.$nextTick(() => {
          this.$refs.companyAdd.init()
        })
      }
    },
    routerjump (menuUrl) {
      if (menuUrl) {
        if (menuUrl === 'enterpriseCertification') {
          this.$router.replace({
            name: menuUrl,
            query: {
              cId: this.$store.state.user.defaultCompanyId
            }
          })
        } else {
          this.$router.replace({ name: menuUrl })
        }
      }
    }
  }
}
</script>
<style>
.el-badge__content.is-fixed {
  top: 7px !important;
}
</style>
<style lang='scss' scoped>
.organization-manage .organization-manage {
  padding: 5px;
  .search-box {
    align-items: center;
    color: #ecc78a;
    .auth-company {
      background-color: #ecc78a;
      color: #333;
      padding: 3px 10px;
      font-size: 10px;
      border-radius: 10px;
    }
  }
  .org-nav {
    display: flex;
    .org-nav-item {
      margin-right: 20px;
      cursor: pointer;
      padding-bottom: 3px;
      &:hover {
        color: #1d65a8;
      }
    }
    .org-nav-item-selected {
      color: #1d65a8;
      border-bottom: 3px #1d65a8 solid;
    }
  }
}
</style>
